import { useMutation, useQuery } from "react-query";
import userWalletApi from "../apis/wallet";

const {
  getWalletAccountDetails,
  initiateCheckoutToFundWallet,
  payOrderFromBatch,
  getPurchaseHistory,
  getWalletTransactions
} = userWalletApi;

export const useGetWalletAccountDetails = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return getWalletAccountDetails(payload);
    },
    onSuccess,
    onError,
  });
};
export const useInitiateCheckoutToFundWallet = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return initiateCheckoutToFundWallet(payload);
    },
    onSuccess,
    onError,
  });
};
export const usePayOrderFromBatch = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return payOrderFromBatch(payload);
    },
    onSuccess,
    onError,
  });
};
export const useGetPurchaseHistory = (
  remark,
  pageNum,
  pageSize,
  onSuccess,
  onError
) =>
  useQuery(
    ["" + remark, pageNum, pageSize],
    () => getPurchaseHistory(pageNum, pageSize),
    {
      onSuccess,
      onError,
      refetchOnWindowFocus: false,
    }
  );

  export const useGetWalletTransactions = (
    remark,
    pageNum,
    pageSize,
    onSuccess,
    onError
  ) =>
    useQuery(
      ["" + remark, pageNum, pageSize],
      () => getWalletTransactions(pageNum, pageSize),
      {
        onSuccess,
        onError,
        refetchOnWindowFocus: false,
      }
    );
